import React, { useEffect, memo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setChildPageName, setPageName } from '../../../../../redux'
import ProductsTable from '../../../../tabels/ProductsTable'
import { getData } from '../../../../../assets/scripts/GeneralFunctions'
import SearchBox from '../SearchBox'

function Oil() {
  const dispatch = useDispatch()
  const [products, setProducts] = useState([NaN, NaN])
  const [products_types, setProducts_types] = useState()
  const [searchValue, setSearchValue] = useState('')

  useEffect(() => {
    async function fetchData() {
      dispatch(setPageName('products'))
      dispatch(setChildPageName('oil'))
      let api_result = await getData(
        'admin/site-options/products',
        'get',
        { filter: 'خدمات تعویض روغن' },
        true
      )
      if (api_result) {
        if (api_result?.status === 200) {
          let result_data = api_result?.data
          setProducts(result_data?.products)
          setProducts_types(result_data?.products_types)
        }
      }
    }

    fetchData()
  }, [])

  const searchResult = (value) => {
    setSearchValue(value)
  }

  return (
    <div>
      <div className="flex justify-between">
        <h1 className="text-xl my-auto dark:text-amber-50">لیست محصولات تعویض روغنی</h1>
        <div>
          <SearchBox
            category={'خدمات تعویض روغن'}
            products={products}
            setProducts={setProducts}
            products_types={products_types}
            searchResult={searchResult}
          />
        </div>
      </div>
      <div className={'md:py-8'}>
        <ProductsTable searchValue={searchValue} products={products} />
      </div>
    </div>
  )
}

export default memo(Oil)
